import {useOutletContext} from 'react-router'
import {Button} from 'brand/Button'
import {justValues, occasions} from './answers'

const answers = justValues(occasions)

export const Occasion = () => {
  const {submitAnswers} = useOutletContext()
  return (
    <div className="column">
      <section className="question">
        <div className="content size-xl">The occasion is...</div>
      </section>
      <section className="answers">
        <div className="content">
          {answers.map(it => (
            <Button
              size="large"
              action={() => submitAnswers([it])}
              key={it}
            >
              {it}
            </Button>
          ))}
        </div>
      </section>
    </div>
  )
}
